var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxer2On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.34 9.55v-.41a7.64 7.64 0 0 1 15.3 0v.41m-15.3 0h-.17A3.2 3.2 0 0 0 1 12.8a3.2 3.2 0 0 0 3.17 3.24h.2c.4 3.48 3.68 6.47 7.62 6.47 3.93 0 7.22-2.99 7.6-6.47h.24A3.2 3.2 0 0 0 23 12.8a3.2 3.2 0 0 0-3.17-3.24h-.2m-15.3 0v6.48m15.3-6.48v6.48m0-.68H14.9c-.52 0-1.02-.18-1.41-.52a2.2 2.2 0 0 0-2.82 0c-.4.34-.9.52-1.41.52H4.34m10.98 2.15a3.59 3.59 0 0 1-3.46 2.36c-.97 0-1.86-.36-2.52-.95m4.6-15.14-3.88 3.4m0-3.4 3.88 3.4m-3.33 3.3c0-2.07-2.58-2.07-2.58 0v.5c0 1.82 2.58 1.82 2.58 0v-.5Zm5.24 0c0-2.07-2.58-2.07-2.58 0v.5c0 1.82 2.58 1.82 2.58 0v-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxer2On);
export default __webpack_public_path__ + "static/media/uxer_2_on.8bfa2cad5a8e50783229118ee3066b96.svg";
export { ForwardRef as ReactComponent };